<template>
    <div>
        <base-header class="pb-6" type="">
            <b-row class="align-items-center py-4">
                <b-col lg="6" cols="7">
                <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                <h6 class="h2 d-inline-block mb-0">{{ language_terms[$route.name] }}</h6>
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                    <route-breadcrumb/>
                </nav>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6 container-padding">
            <div>
                <loading :active.sync="loading" 
                    color= '#007bff'
                    :width= '128'
                    :height= '128'
                    loader='dots'
                    :can-cancel="true" 
                    :is-full-page="true">
                </loading>
                <b-row>
                    <b-col cols="12">
                        <div class="card-wrapper">
                            <b-card>
                                <div slot="header">
                                    <b-row>
                                        <b-col cols="10">
                                            <h3>{{title}}</h3>
                                        </b-col>
                                        <b-col cols="2">
                                            <i class="fa fa-exclamation-triangle float-right text-red fa-3x" v-if="voucher.is_void == '1'" ></i>
                                        </b-col>
                                    </b-row>
                                </div>
                                <b-row>
                                    <b-col cols="4" v-if="!hasQueryVar && $route.params.id == '_new'">
                                        <base-input :label="language_terms['FINANCIAL_YEAR']" >
                                            <el-select v-model="voucher.fy" filterable :placeholder="language_terms['FINANCIAL_YEAR']" @change="onChangeFinancialYear">
                                                <el-option v-for="option in valid_fys"
                                                        :key="option.fy"
                                                        :label="option.fy"
                                                        :value="option.fy"
                                                        >
                                                </el-option>
                                            </el-select>
                                        </base-input>
                                    </b-col>
                                    <b-col cols="4" v-if="!hasQueryVar && $route.params.id == '_new'">
                                        <base-input :label="language_terms['ACCOUNT']" >
                                            <el-select v-model="voucher.account_item_id" filterable :placeholder="language_terms['ACCOUNT']">
                                                <el-option v-for="option in account_list"
                                                        :key="option.id"
                                                        :label="option.display_name"
                                                        :value="option.id">
                                                </el-option>
                                            </el-select>
                                        </base-input>
                                    </b-col>
                                    <b-col cols="4" v-if="hasQueryVar || disabledField">
                                        <base-input :label="language_terms['FINANCIAL_YEAR']" v-model="voucher.fy" disabled></base-input>
                                    </b-col>
                                    <b-col cols="4" v-if="hasQueryVar || disabledField">
                                        <base-input :label="language_terms['ACCOUNT_CODE']" v-model="voucher.account_display_name" disabled></base-input>
                                    </b-col>
                                    <b-col cols="4" v-if="disabledField">
                                        <base-input :label="language_terms['DATE']" v-model="voucher.voucher_date" disabled type="date"></base-input>
                                    </b-col>
                                    <b-col cols="4" v-else>
                                        <base-input :label="language_terms['DATE']">
                                            <flat-picker
                                                slot-scope="{ focus, blur }"
                                                @on-open="focus"
                                                @on-close="blur"
                                                style="background-color: white"
                                                class="form-control datepicker"
                                                v-model="voucher.voucher_date">
                                            </flat-picker>
                                        </base-input>
                                    </b-col>
                                    <b-col cols="4">
                                        <base-input :label="language_terms['REFERENCE']" v-model="voucher.reference" :disabled="disabledField"></base-input>
                                    </b-col>
                                    <b-col cols="4">
                                        <base-input :label="language_terms['DIRECTION']">
                                            <el-select
                                                :disabled="disabledField"
                                                v-model="voucher.direction"
                                                filterable
                                                :placeholder="language_terms['DIRECTION']">
                                                <el-option
                                                    v-for="option in direction_options"
                                                    :key="option.code"
                                                    :label="language_terms[option.name]"
                                                    :value="option.code">
                                                </el-option>
                                            </el-select>
                                        </base-input>  
                                    </b-col>
                                    <b-col cols="4">
                                        <base-input :label="language_terms['AMOUNT']" v-model="voucher.amount" type="number" :disabled="disabledField"></base-input>
                                    </b-col>
                                    <b-col cols="12">
                                        <base-input :label="language_terms['REMARKS']">
                                            <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="voucher.remarks" :disabled="disabledField"></textarea>
                                        </base-input>
                                    </b-col>
                                    <b-col cols="12">
                                        <base-button type="primary" @click="save" class="mt-4 mr-4" v-if="!disabledField">{{language_terms['SAVE']}}</base-button>
                                        <base-button type="warning" @click="voidVoucher" class="mt-4 mr-4" v-if="allowVoid">{{language_terms['VOID']}}</base-button>

                                        <base-button type="danger" @click="cancel" class="mt-4">{{language_terms['CLOSE']}}</base-button>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </b-container>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Select, Option } from "element-ui";
import moment from "moment";

export default {
  components:{
    Loading,
    flatPicker,
    [Select.name]: Select,
    [Option.name]: Option
  },
  computed:{
    ...mapState({
        language_terms:(state)=>state.languages.language_terms,
        voucher_filter:(state) => state.vouchers.voucher_filter,
        account_data: state => state.accounts.data,
        is_created: state => state.accounts.is_voucher_created,
        is_voided: state => state.accounts.is_voucher_voided,
        voucher_data: state => state.accounts.voucher,
        fys: (state) => state.accounts.fys,
        accounts_for_fy: (state) => state.accounts.accounts_for_fy

    })
  },
  data(){
      return{
          loading:false,
          allowVoid:false,
          title:"",
          hasQueryVar:false,
          disabledField:false,
          direction_options:[
              {code: "DR", name:"DEBIT"},
              {code: "CR", name:"CREDIT"}
          ],
          valid_fys:[],
          account_list:[],
          voucher:{
              voucher_date:"",
              account_item_code:"",
              account_display_name:"",
              account_item_id:"",
              fy:"",
              amount:null,
              direction:"",
              remarks:"",
              reference:"",
              voucher_type:"VOUCHER"
          }
      }
  },
  async mounted()
  {
      this.loading = true
      let id = this.$route.params.id

      if(id == '_new')
      {
        this.title = this.language_terms["NEW_VOUCHER"]
        this.voucher.voucher_date = moment().format("YYYY-MM-DD");
        await this.$store.dispatch("accounts/fetchFYs", {})

        if(this.fys)
        {
            this.valid_fys = this.fys.filter(function(item)
                            {
                                return (item.fy != null);
                            });
        }

        let account_item_id = this.$route.query.account_id

        if(account_item_id)
        {
            await this.$store.dispatch("accounts/fetch", {id:account_item_id})

            if(this.account_data)
            {
                this.voucher.fy = this.account_data.fy
                this.voucher.account_item_code = this.account_data.account_item_code
                this.voucher.account_display_name = this.account_data.display_name
                this.voucher.account_item_id = this.account_data.id
                this.hasQueryVar = true
            }
        }

      }
      else
      {
        await this.$store.dispatch("accounts/fetchVoucher", {voucher_code: id})
        this.voucher = this.voucher_data
        this.title = this.voucher.voucher_code
        this.disabledField = true

        if(this.voucher.allow_void)
        {
            this.allowVoid = true
        }
      }

      this.loading = false

  },
  methods:{
    async searchVouchers()
    {
        this.isLoading = true
        let filter = {
               keyword:"",
                active_only:"1",
                type:"VOUCHER"
        }
        if(this.voucher_filter)
        {
            filter = this.voucher_filter
        }
        await this.$store.dispatch('vouchers/quickSearch', filter)

        this.isLoading = false
    },
      async voidVoucher()
      {
            await this.$store.dispatch("accounts/voidVoucher", {id:this.voucher.id})

            if(this.is_voided == 1)
            {
                await this.searchVouchers()
                this.$router.push("/finance/vouchers")
            }
      },
      async save()
      {
        await this.$store.dispatch("accounts/createVoucher", this.voucher)

        if(this.is_created == 1)
        {
            await this.searchVouchers()
            this.$router.push("/finance/vouchers")
        }
      },
     onChangeFinancialYear()
      {
        this.getAllAccountsForFY()
      },
      async getAllAccountsForFY()
      {
        this.loading = true;
        let filter = {fy:this.voucher.fy}
        await this.$store.dispatch("accounts/getAccountForFys", filter)
        this.account_list = this.accounts_for_fy

        this.loading = false;
      },
      cancel()
      {
        this.$router.push("/finance/vouchers")
      }
  }
}
</script>
